import PropTypes from 'prop-types';
import React, { useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { REGISTER_NOTIFICATION } from '../../brands/default/content/components/checkout';
import { hasUserSetPassword } from '../../helpers/user';
import ThemeContext from '../../providers/ThemeProvider';
import { LOADING_STATUS } from '../../redux/reducers/loading';
import Message from '../_generic/Message';
import Spinner from '../_generic/spinner/Spinner';
import Tile from '../_generic/tile/Tile';
import TileBody from '../_generic/tile/TileBody';
import Login from '../login/LoginForm';
import FormRegistration from '../registration/FormRegistration';
import UserLoginTitle from './details/UserLoginTitle';
import { panel } from './details/UserPanelSetup';
import UserRegistrationTitle from './details/UserRegistrationTitle';

const LoginDetails = ({
  showMessage = false,
  setShowModal,
  setEnablePaymentModule,
}) => {
  let tileBody;
  let tileTitle;
  const userStore = useSelector((state) => state.user);
  const [status] = useSelector((state) => [state.profile.status]);
  const theme = useContext(ThemeContext);
  const [activePanel, setActivePanel] = useState(null);

  useEffect(() => {
    let active = hasUserSetPassword() ? panel.login : panel.registration;
    if (userStore.isAuthenticated) active = panel.details;
    setActivePanel(active);
  }, [userStore.isAuthenticated]);

  if (activePanel === panel.details) {
    setShowModal(false);
    setEnablePaymentModule(true);
  }
  if (activePanel === panel.login) {
    tileTitle = <UserLoginTitle setActivePanel={setActivePanel} vipPaywall />;
    tileBody = <Login setActivePanel={setActivePanel} vipPaywall />;
  }
  if (activePanel === panel.registration) {
    tileTitle = <UserRegistrationTitle setActivePanel={setActivePanel} />;
    tileBody = (
      <>
        <FormRegistration
          isCheckout
          setActivePanel={setActivePanel}
          vipPaywall
        />
        {showMessage && (
          <Message
            iconPosition="left"
            message={REGISTER_NOTIFICATION}
            zIndex={0}
          />
        )}
      </>
    );
  }

  return (
    <>
      <div className="position-relative">
        {status === LOADING_STATUS.LOADING && <Spinner hasMsg={false} />}
        <Tile extraClasses="your-details" title={tileTitle}>
          <TileBody nobackground>{tileBody}</TileBody>
        </Tile>
      </div>
      <style global jsx>{`
        .details-title__right-block {
          font-size: 15px;
          font-weight: 700;
          font-style: italic;
        }
        .details-title__right-block a {
          color: ${theme.colors.primary};
        }
        @media (max-width: ${theme.breakpoints.lgDown}) {
          :global(.tile--your-details) {
            margin-bottom: 30px;
          }
        }
        @media (max-width: ${theme.breakpoints.mdDown}) {
          :global(.tile--your-details) {
            margin-bottom: 0;
          }
        }
        :global(.tile--your-details) {
          background-color: black;
          color: white;
        }
      `}</style>
    </>
  );
};

LoginDetails.propTypes = {
  setEnablePaymentModule: PropTypes.func,
  setShowModal: PropTypes.func,
  showMessage: PropTypes.bool,
};

export default LoginDetails;
